import { render, staticRenderFns } from "./cardetail.vue?vue&type=template&id=03da022a&scoped=true"
import script from "./cardetail.vue?vue&type=script&lang=js"
export * from "./cardetail.vue?vue&type=script&lang=js"
import style0 from "./cardetail.vue?vue&type=style&index=0&id=03da022a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03da022a",
  null
  
)

export default component.exports